import { v1 as uuidv1 } from 'uuid'
import eventBus from '../../eventBus'

export default {
  name: 'AddToComparisonWidget',

  // language=HTML
  template: `
    <div class="product-comparison-checkbox-widget">
      <input
        type="checkbox"
        :id="id"
        :checked="checked"
        @click="handleClick"
      >
      <label v-if="checked" :for="id">In Compare</label>
      <label v-else :for="id">Add to Compare</label>
    </div>
  `,

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      id: uuidv1(),
      checked: false,
    }
  },

  computed: {
    comparisonProductIds() {
      return this.$store.state.productIds
    },

    ariaChecked() {
      return this.checked ? 'true' : 'false'
    },
  },

  watch: {
    comparisonProductIds: {
      immediate: true,
      handler() {
        this.checked = this.comparisonProductIds.indexOf(this.product.id) !== -1
      },
    },
  },

  methods: {
    handleClick() {
      const newValue = !this.checked
      if (newValue) {
        eventBus.$emit('add-product-to-comparison', this.product)
      } else {
        eventBus.$emit('remove-product-from-comparison', this.product.id)
      }
    },
  },
}
